/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 12
// module chunks = 0